<sbnb-apps-detail-page
  vendorCode="tidy"
  name="TIDY"
  logoTile="/assets/images/apps/tidy.png"
  builtBy="TIDY"
  builtByLink="https://www.tidy.com/"
  [categories]="['Operations']"
  [permissions]="[AppPermission.propertyListingRead, AppPermission.reservationRead, AppPermission.calendarRead]"
  email="concierge@tidy.com"
  [helpArticles]="[
    {
      id: '10406993',
      title: 'Connect Hospitable with TIDY to Automate Cleaning and Maintenance Operations'
    }
  ]">
  <ng-container description>
    <p>
      TIDY is an AI and automation company founded in 2014 looking to fully automate cleaning and maintenance operations
      for companies and individuals. By combining AI-powered technology, software, and humans (Concierge), TIDY
      automates up to 90% of manual tasks, reducing the need for repetitive effort, which helps managers save time, cut
      costs, and streamline operations.
    </p>

    <p class="mt-4">
      In these last 10 years, TIDY has become a trusted property operations platform by thousands of property managers
      and hosts, serving a diverse client base across the US, Europe, and Latin America. With a mission to bridge the
      gap between AI automation and human precision, TIDY ensures properties are always guest-ready, delivering
      exceptional operational efficiency and quality.
    </p>

    <h3 class="text-lg font-medium mt-6 mb-2">Key Features:</h3>
    <ul class="list-disc pl-6 space-y-2">
      <li>
        <strong>Smart Workflows:</strong>
        Automate scheduling, vendor coordination, and quality control with customizable workflows.
      </li>
      <li>
        <strong>AI + Human Concierge:</strong>
        Our AI handles routine tasks, while human support fills gaps to ensure seamless operations.
      </li>
      <li>
        <strong>Predictive Insights:</strong>
        Identify potential issues before they arise with predictive AI for smoother management.
      </li>
      <li>
        <strong>Automated Restocking:</strong>
        TIDY's AI-powered restocking workflows monitor supply levels and automatically trigger replenishment, ensuring
        you're always stocked and guest-ready.
      </li>
      <li>
        <strong>Inventory Management:</strong>
        AI-powered restocking workflows automatically replenish supplies, keeping properties guest-ready.
      </li>
      <li>
        <strong>Full-Service Coordination:</strong>
        The TIDY team manages every aspect of cleaning and maintenance remotely, removing the need for an in-house
        operations team.
      </li>
    </ul>

    <p class="mt-4">
      With TIDY, property managers save time, reduce operational costs, and deliver an elevated experience for guests
      and property owners alike. TIDY automates 90% of cleaning and maintenance workflows today, targeting 100% by 2026.
    </p>

    <div class="mt-5" style="position: relative; padding-bottom: 56.25%; height: 0">
      <iframe
        src="https://www.loom.com/embed/35885981be164d64bee900752c1a73a8"
        frameborder="0"
        allowfullscreen
        data-qa="tidy-demo-video"
        style="position: absolute; top: 0; left: 0; width: 100%; height: 100%"></iframe>
    </div>
    <sbnb-image-carousel
      [images]="[
        '/assets/images/apps/tidy/1.png',
        '/assets/images/apps/tidy/2.png',
        '/assets/images/apps/tidy/3.png',
      ]"></sbnb-image-carousel>
  </ng-container>
</sbnb-apps-detail-page>
